"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  id: 1,
  author: "John D.",
  role: "East Texas Ranch Owner",
  quote: "Shark Bite Land Clearing transformed my property quickly and professionally. The difference is night and day—highly recommended for anyone needing serious work done.",
  rating: 5
}, {
  id: 2,
  author: "Lisa M.",
  role: "Property Owner",
  quote: "Reliable, insured, and efficient — they did the job right the first time. It's rare to find a team that communicates this well and delivers exactly what was promised.",
  rating: 5
}, {
  id: 3,
  author: "Mark T.",
  role: "Longview Landowner",
  quote: "Cleared 50 acres of dense underbrush without breaking a sweat. That Kubota SVL973 is a beast, and the operator knew exactly how to handle the terrain.",
  rating: 5
}, {
  id: 4,
  author: "Sarah J.",
  role: "Tyler Property Manager",
  quote: "Best investment for our hunting lease. They left clean lines and no mess behind. The forestry mulching finish is perfect for maintaining the land.",
  rating: 5
}, {
  id: 5,
  author: "Robert K.",
  role: "Cattle Rancher",
  quote: "I needed pasture reclaimed from years of overgrowth. Shark Bite came in and reclaimed acres of usable land in just a few days. Professional and tough.",
  rating: 5
}];
export default function RanchOwnerReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ranch-owner-reviews" ref={ref} className={cn("dark bg-background text-foreground relative overflow-hidden py-24", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-1000 ease-out")}>
      {}
      <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.03] select-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569013/img/shark_bite_logo_watermark.png" alt="" className="h-[600px] w-auto object-contain grayscale" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-16 text-center">
          <h2 className="text-primary mb-4 text-lg font-bold uppercase tracking-widest">
            Client Testimonials
          </h2>
          <h3 className="font-serif text-4xl font-bold tracking-tight sm:text-5xl">
            Trusted by East Texas Landowners
          </h3>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
            See what ranch owners and property managers are saying about our
            land clearing and forestry mulching services.
          </p>
        </div>

        <div className="mx-auto max-w-5xl">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/2">
                  <div className="h-full p-1">
                    <Card className="bg-card/40 border-white/10 hover:border-primary/30 hover:bg-card/60 h-full backdrop-blur-sm transition-all duration-300">
                      <CardContent className="flex h-full flex-col justify-between p-8">
                        <div>
                          <div className="mb-6 flex items-center gap-1">
                            {[...Array(testimonial.rating)].map((_, index) => <Star key={index} className="text-primary size-5 fill-current" />)}
                          </div>
                          <Quote className="text-muted-foreground/20 mb-4 size-10" />
                          <blockquote className="font-serif text-xl leading-relaxed text-pretty">
                            "{testimonial.quote}"
                          </blockquote>
                        </div>

                        <div className="mt-8 border-t border-white/10 pt-6">
                          <div className="font-sans font-bold text-lg">
                            {testimonial.author}
                          </div>
                          <div className="text-primary text-sm font-medium uppercase tracking-wider">
                            {testimonial.role}
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="mt-12 flex justify-center gap-4">
              <CarouselPrevious className="static translate-y-0 hover:bg-primary hover:text-primary-foreground border-white/10 bg-transparent text-white" />
              <CarouselNext className="static translate-y-0 hover:bg-primary hover:text-primary-foreground border-white/10 bg-transparent text-white" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}